<template>
  <div class="nt-form__item">
    <input type="submit" id="btn-submit" :value="text" :class="classes" :style="style" :disabled="disabled" />
  </div>
</template>
 
<script>
export default {
  name: 'NtFormISubmit',
  props: {
    text: {
      type: String,
      default: 'Submit'
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    theme: {
      type: String,
      default: 'default'
    },
    fontSize: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getTheme() {
      return `button--${this.theme}`
    },
    getShape() {
      return this.rounded ? '' : 'button--squared'
    },
    classes() {
      return ['button', 'button-full', this.getShape, this.getTheme, this.disabled ? 'button--disabled' : '']
    },
    style() {
      return {
        'font-size': isNaN(this.fontSize) ? this.fontSize : `${this.fontSize}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .button {
    border: 0;
    
    &--small {
      width: auto;
      font-size: 1rem
    }

    &--disabled {
      background-color: #3b3b3b;
      color: #f6f7f8;
      pointer-events: none;
    }
  }
</style>